import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import BooksApp from './App';

ReactDOM.render(
    <BooksApp />,
    document.getElementById('root')

)
